import React, { ReactNode, KeyboardEvent } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import icons from '../../../constants/icons';

export interface SlideoutLayoutProps {
  title?: string;
  bar?: ReactNode;
  cancel: () => void;
  done?: () => void;
  hideBar?: boolean;
  /** When true, content area fills height and does not scroll; use with flex + overflow-auto inside for per-panel scrolling */
  contentFillHeight?: boolean;
  children?: ReactNode;
}

const SlideoutLayout: React.FC<SlideoutLayoutProps> = ({
  title,
  bar,
  cancel,
  hideBar = false,
  contentFillHeight = false,
  children,
}) => {
  const { t } = useTranslation();

  const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter') {
      cancel();
    }
  };

  return (
    <>
      <header className="clearfix width-100">
        <div className="width-100">
          {title ? <h1 className="no-margin">{title}</h1> : null}
        </div>
        <div
          className="icon-wrapper"
          tabIndex={0}
          onClick={cancel}
          onKeyDown={handleKeyDown}
          title={t('Close')}
        >
          <FontAwesomeIcon
            icon={icons.CLOSE}
            className="cursor-pointer me-2"
            size="2x"
          />
        </div>
      </header>
      {!hideBar && <div className="bar bar-end text-right">{bar}</div>}
      <div
        className={
          contentFillHeight
            ? 'content content-fill overflow-hidden'
            : 'content'
        }
      >
        {children}
      </div>
    </>
  );
};

export default SlideoutLayout;
